// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VitalsAndLabsModule-module__font-s-10___c97oU {
  font-size: 10px !important;
}

.VitalsAndLabsModule-module__font-s-12___W_86y {
  font-size: 12px !important;
}

.VitalsAndLabsModule-module__font-s-13___Ol1Q7 {
  font-size: 13px !important;
}

.VitalsAndLabsModule-module__font-s-14___qCRNC {
  font-size: 14px !important;
}

.VitalsAndLabsModule-module__font-s-15___cmffw {
  font-size: 15px !important;
}

.VitalsAndLabsModule-module__font-s-16___jnQt1 {
  font-size: 16px !important;
}

.VitalsAndLabsModule-module__font-s-18___TUoxr {
  font-size: 18px !important;
}

.VitalsAndLabsModule-module__font-s-20___Tl2nZ {
  font-size: 20px !important;
}

.VitalsAndLabsModule-module__font-s-22___zUw1u {
  font-size: 22px !important;
}

.VitalsAndLabsModule-module__font-s-28___H1LcE {
  font-size: 28px !important;
}

.VitalsAndLabsModule-module__font-w-400___cBUp6 {
  font-weight: 400 !important;
}

.VitalsAndLabsModule-module__font-w-500___jUrD5 {
  font-weight: 500 !important;
}

.VitalsAndLabsModule-module__font-w-600___v8eAa {
  font-weight: 600 !important;
}

.VitalsAndLabsModule-module__font-w-700___opYTU {
  font-weight: 700 !important;
}

.VitalsAndLabsModule-module__p-5___GkW9G {
  padding: 5px !important;
}

.VitalsAndLabsModule-module__p-12___PNWIR {
  padding: 12px !important;
}

.VitalsAndLabsModule-module__p-16___RiPr5 {
  padding: 16px !important;
}

.VitalsAndLabsModule-module__p-30___vZ1PU {
  padding: 30px !important;
}

.VitalsAndLabsModule-module__p-b-0___nVy4x {
  padding-bottom: 0 !important;
}

.VitalsAndLabsModule-module__p-b-5___BzToY {
  padding-bottom: 5px !important;
}

.VitalsAndLabsModule-module__p-b-10___UNVtj {
  padding-bottom: 10px !important;
}

.VitalsAndLabsModule-module__p-b-12___Dk8bT {
  padding-bottom: 12px !important;
}

.VitalsAndLabsModule-module__p-b-16___qQpCI {
  padding-bottom: 16px !important;
}

.VitalsAndLabsModule-module__p-b-18___wGjmT {
  padding-bottom: 18px !important;
}

.VitalsAndLabsModule-module__p-b-20___eQoze {
  padding-bottom: 20px !important;
}

.VitalsAndLabsModule-module__p-b-25___qGNZW {
  padding-bottom: 25px !important;
}

.VitalsAndLabsModule-module__p-b-30___QX9SX {
  padding-bottom: 30px !important;
}

.VitalsAndLabsModule-module__p-b-50___Ge2dm {
  padding-bottom: 50px !important;
}

.VitalsAndLabsModule-module__p-t-0___g2A0k {
  padding-top: 0 !important;
}

.VitalsAndLabsModule-module__p-t-12___Mx5jL {
  padding-top: 12px !important;
}

.VitalsAndLabsModule-module__p-t-16___OC_B5 {
  padding-top: 16px !important;
}

.VitalsAndLabsModule-module__p-t-18___zaSPL {
  padding-top: 18px !important;
}

.VitalsAndLabsModule-module__p-t-20___rC6fO {
  padding-top: 20px !important;
}

.VitalsAndLabsModule-module__p-t-30___u0OMB {
  padding-top: 30px !important;
}

.VitalsAndLabsModule-module__p-t-40___PmU5r {
  padding-top: 40px !important;
}

.VitalsAndLabsModule-module__p-t-50___lf37y {
  padding-top: 50px !important;
}

.VitalsAndLabsModule-module__p-l-20___KK7_n {
  padding-left: 20px !important;
}

.VitalsAndLabsModule-module__p-l-30___OKOtf {
  padding-left: 30px !important;
}

.VitalsAndLabsModule-module__p-l-40___oEWxi {
  padding-left: 40px !important;
}

.VitalsAndLabsModule-module__p-r-16___re5M4 {
  padding-right: 16px !important;
}

.VitalsAndLabsModule-module__p-r-20___cJbA6 {
  padding-right: 20px !important;
}

.VitalsAndLabsModule-module__p-r-30___Z99r0 {
  padding-right: 30px !important;
}

.VitalsAndLabsModule-module__p-r-50___ZhE0C {
  padding-right: 50px !important;
}

.VitalsAndLabsModule-module__p-r-60___ILfJd {
  padding-right: 60px !important;
}

.VitalsAndLabsModule-module__m-b-1___OKCBi {
  margin-bottom: 1px !important;
}

.VitalsAndLabsModule-module__m-b-2___OYZWd {
  margin-bottom: 2px !important;
}

.VitalsAndLabsModule-module__m-b-6___jDLDH {
  margin-bottom: 6px !important;
}

.VitalsAndLabsModule-module__m-b-8___F4k5m {
  margin-bottom: 8px !important;
}

.VitalsAndLabsModule-module__m-b-10___Z6RDH {
  margin-bottom: 10px !important;
}

.VitalsAndLabsModule-module__m-b-14___bqXrk {
  margin-bottom: 14px !important;
}

.VitalsAndLabsModule-module__m-b-16___KP0Jy {
  margin-bottom: 16px !important;
}

.VitalsAndLabsModule-module__m-b-20___yaKQy {
  margin-bottom: 20px !important;
}

.VitalsAndLabsModule-module__m-b-22___VlNcH {
  margin-bottom: 22px !important;
}

.VitalsAndLabsModule-module__m-b-24___iUp92 {
  margin-bottom: 24px !important;
}

.VitalsAndLabsModule-module__m-b-30___tQyq6 {
  margin-bottom: 30px !important;
}

.VitalsAndLabsModule-module__m-b-32___pPPjk {
  margin-bottom: 32px !important;
}

.VitalsAndLabsModule-module__m-b-40___nB74C {
  margin-bottom: 40px !important;
}

.VitalsAndLabsModule-module__m-t-2___lDjph {
  margin-top: 2px !important;
}

.VitalsAndLabsModule-module__m-t-3___XMspH {
  margin-top: 3px !important;
}

.VitalsAndLabsModule-module__m-t-4___kB3iz {
  margin-top: 4px !important;
}

.VitalsAndLabsModule-module__m-t-5___ao4ac {
  margin-top: 5px !important;
}

.VitalsAndLabsModule-module__m-t-8___wmvle {
  margin-top: 8px !important;
}

.VitalsAndLabsModule-module__m-t-10___RN63Q {
  margin-top: 10px !important;
}

.VitalsAndLabsModule-module__m-t-15___CrrcQ {
  margin-top: 15px !important;
}

.VitalsAndLabsModule-module__m-t-16___KRAQ6 {
  margin-top: 16px !important;
}

.VitalsAndLabsModule-module__m-t-20___HFh4q {
  margin-top: 20px !important;
}

.VitalsAndLabsModule-module__m-t-22___VCd9f {
  margin-top: 22px !important;
}

.VitalsAndLabsModule-module__m-t-30___qD85D {
  margin-top: 30px !important;
}

.VitalsAndLabsModule-module__m-t-32___riM05 {
  margin-top: 32px !important;
}

.VitalsAndLabsModule-module__m-l-auto___yrQrp {
  margin-left: auto !important;
}

.VitalsAndLabsModule-module__m-l-4___ROrTn {
  margin-left: 4px !important;
}

.VitalsAndLabsModule-module__m-l-5___p7O2F {
  margin-left: 5px !important;
}

.VitalsAndLabsModule-module__m-l-6___FHr2w {
  margin-left: 6px !important;
}

.VitalsAndLabsModule-module__m-l-8___dG9lL {
  margin-left: 8px !important;
}

.VitalsAndLabsModule-module__m-l-10___AbthJ {
  margin-left: 10px !important;
}

.VitalsAndLabsModule-module__m-l-16___geF9T {
  margin-left: 16px !important;
}

.VitalsAndLabsModule-module__m-l-20___CZoeu {
  margin-left: 20px !important;
}

.VitalsAndLabsModule-module__m-l-24___oxJ0C {
  margin-left: 24px !important;
}

.VitalsAndLabsModule-module__m-l-30___frMKI {
  margin-left: 30px !important;
}

.VitalsAndLabsModule-module__m-l-35___uS_xt {
  margin-left: 35px !important;
}

.VitalsAndLabsModule-module__m-l-40___ma_bB {
  margin-left: 40px !important;
}

.VitalsAndLabsModule-module__m-r-8___IdqFO {
  margin-right: 8px !important;
}

.VitalsAndLabsModule-module__m-r-10____2lO0 {
  margin-right: 10px !important;
}

.VitalsAndLabsModule-module__m-r-16___o8djO {
  margin-right: 16px !important;
}

.VitalsAndLabsModule-module__m-r-20___h07eO {
  margin-right: 20px !important;
}

.VitalsAndLabsModule-module__m-r-24___hihtC {
  margin-right: 24px !important;
}

.VitalsAndLabsModule-module__m-r-30___oP43G {
  margin-right: 30px !important;
}

.VitalsAndLabsModule-module__m-r-40___hrblG {
  margin-right: 40px !important;
}

.VitalsAndLabsModule-module__border-r-3___bgQ7s {
  border-radius: 3px !important;
}

.VitalsAndLabsModule-module__border-r-4___FJSqj {
  border-radius: 4px !important;
}

.VitalsAndLabsModule-module__border-r-6___QS9B3 {
  border-radius: 6px !important;
}

.VitalsAndLabsModule-module__border-r-10___CEBtI {
  border-radius: 10px !important;
}

.VitalsAndLabsModule-module__border-r-12___kXAjh {
  border-radius: 12px !important;
}

.VitalsAndLabsModule-module__border-r-16___i8yQj {
  border-radius: 16px !important;
}

.VitalsAndLabsModule-module__border-r-50___GG5Ay {
  border-radius: 50% !important;
}

.VitalsAndLabsModule-module__primary-border___SBmI1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.VitalsAndLabsModule-module__primary-border-b___Dmi2x {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.VitalsAndLabsModule-module__primary-border-t___zkp81 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.VitalsAndLabsModule-module__primary-border-l___g4mIK {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.VitalsAndLabsModule-module__primary-border-r___iZTii {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.VitalsAndLabsModule-module__secondary-border___ykOs0 {
  border: 1px solid #637768;
}

.VitalsAndLabsModule-module__secondary-border-b___UJlxp {
  border-bottom: 1px solid #637768;
}

.VitalsAndLabsModule-module__secondary-border-t___CGJje {
  border-top: 1px solid #637768;
}

.VitalsAndLabsModule-module__secondary-border-l___anxyU {
  border-left: 1px solid #637768;
}

.VitalsAndLabsModule-module__secondary-border-r___oNcYO {
  border-right: 1px solid #637768;
}

.VitalsAndLabsModule-module__gap-0___m85Nu {
  gap: 0 !important;
}

.VitalsAndLabsModule-module__gap-2___JLz_s {
  gap: 2px !important;
}

.VitalsAndLabsModule-module__gap-4___X5m72 {
  gap: 4px !important;
}

.VitalsAndLabsModule-module__gap-5___j0So5 {
  gap: 5px !important;
}

.VitalsAndLabsModule-module__gap-6___bryZP {
  gap: 6px !important;
}

.VitalsAndLabsModule-module__gap-8___zlfYq {
  gap: 8px !important;
}

.VitalsAndLabsModule-module__gap-10___KZSJB {
  gap: 10px !important;
}

.VitalsAndLabsModule-module__gap-12___E0pz2 {
  gap: 12px !important;
}

.VitalsAndLabsModule-module__gap-14___kcgnT {
  gap: 14px !important;
}

.VitalsAndLabsModule-module__gap-16___qSkKU {
  gap: 16px !important;
}

.VitalsAndLabsModule-module__gap-18___Q_UK5 {
  gap: 18px !important;
}

.VitalsAndLabsModule-module__gap-20___LDBBw {
  gap: 20px !important;
}

.VitalsAndLabsModule-module__gap-24___KoEv9 {
  gap: 24px !important;
}

.VitalsAndLabsModule-module__gap-26___sG7gg {
  gap: 26px !important;
}

.VitalsAndLabsModule-module__gap-30___Jfv1_ {
  gap: 30px !important;
}

.VitalsAndLabsModule-module__gap-32___FyeXW {
  gap: 32px !important;
}

.VitalsAndLabsModule-module__gap-40___e_V9R {
  gap: 40px !important;
}

.VitalsAndLabsModule-module__gap-50___O_VFp {
  gap: 50px !important;
}

.VitalsAndLabsModule-module__flex-1___GAbTK {
  flex: 1;
}

.VitalsAndLabsModule-module__flex-none___lccQ3 {
  flex: none !important;
}

.VitalsAndLabsModule-module__flex-column___BcXYP {
  display: flex;
  flex-direction: column !important;
}

.VitalsAndLabsModule-module__flex-row___LpPiU {
  display: flex;
  flex-direction: row !important;
}

.VitalsAndLabsModule-module__vertically-centered___dBG_j {
  display: flex;
  align-items: center !important;
}

.VitalsAndLabsModule-module__horizontally-centered___ZZF7s {
  display: flex;
  justify-content: center !important;
}

.VitalsAndLabsModule-module__horizontally-end___kaDoV {
  display: flex;
  justify-content: end !important;
}

.VitalsAndLabsModule-module__vertically-start___D2xem {
  display: flex;
  align-items: start !important;
}

.VitalsAndLabsModule-module__space-between___Lbb_q {
  display: flex;
  justify-content: space-between !important;
}

.VitalsAndLabsModule-module__flex-wrap___RsFKR {
  flex-wrap: wrap !important;
}

.VitalsAndLabsModule-module__height-100___w0WP1 {
  height: 100%;
}

.VitalsAndLabsModule-module__width-50___PMK4T {
  width: 50% !important;
}

.VitalsAndLabsModule-module__width-100___vKG_8 {
  width: 100%;
}

.VitalsAndLabsModule-module__cursor-pointer___L3JNW {
  cursor: pointer;
}

.VitalsAndLabsModule-module__cursor-not-allowed___kyiXv {
  cursor: not-allowed !important;
}

.VitalsAndLabsModule-module__absolute-centered___jeDll {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.VitalsAndLabsModule-module__absolute___Lurkn {
  position: absolute;
}

.VitalsAndLabsModule-module__relative___DhtHY {
  position: relative;
}

.VitalsAndLabsModule-module__fixed___bnRx8 {
  position: fixed;
}

.VitalsAndLabsModule-module__visible___OBqpX {
  opacity: 1;
}

.VitalsAndLabsModule-module__invisible___urw3H {
  opacity: 0;
}

.VitalsAndLabsModule-module__col-90___gihB6 {
  width: 90% !important;
}

.VitalsAndLabsModule-module__col-auto___Oa3Kk {
  width: auto !important;
}

.VitalsAndLabsModule-module__medical-tabs___yhyna {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.VitalsAndLabsModule-module__medical-table-new___F3dNK {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VitalsAndLabsModule-module__medical-table-new___F3dNK:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VitalsAndLabsModule-module__medical-table-new___F3dNK::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VitalsAndLabsModule-module__medical-table-new___F3dNK::-webkit-scrollbar-track {
  display: none;
}
.VitalsAndLabsModule-module__medical-table-new___F3dNK.VitalsAndLabsModule-module__no-pagination___uJgsG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VitalsAndLabsModule-module__medical-table-new___F3dNK.VitalsAndLabsModule-module__no-pagination___uJgsG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VitalsAndLabsModule-module__medical-table-new___F3dNK.VitalsAndLabsModule-module__no-pagination___uJgsG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VitalsAndLabsModule-module__medical-table-new___F3dNK.VitalsAndLabsModule-module__no-pagination___uJgsG::-webkit-scrollbar-track {
  display: none;
}

.VitalsAndLabsModule-module__medical-table-empty___i0KMN {
  padding: 14px 40px !important;
}

.VitalsAndLabsModule-module__icon-btn___Vs_sQ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.VitalsAndLabsModule-module__search-icon___OKLCu {
  width: 24px;
  height: 24px;
  align-self: center;
}

.VitalsAndLabsModule-module__disable-select___janId {
  user-select: none;
}

.VitalsAndLabsModule-module__break-word___LNS3L {
  word-break: break-word;
}

.VitalsAndLabsModule-module__popup-clear-btn___CpqMj {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.VitalsAndLabsModule-module__scroll-m-b-20___czb9b {
  scroll-margin-bottom: 20px;
}

.VitalsAndLabsModule-module__container___PgOhN {
  display: flex;
  flex-direction: column;
  max-width: 40vw;
  color: #375844;
  padding: 14px 30px 14px 0;
  gap: 14px;
}

.VitalsAndLabsModule-module__width50___MG1EI {
  width: 50% !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/VitalsAndLabsModule/VitalsAndLabsModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  flex-direction: column;\n  max-width: 40vw;\n  color: get-color(greenNew, dark);\n  padding: 14px 30px 14px 0;\n  gap: 14px;\n}\n\n.width50 {\n  width: 50% !important;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `VitalsAndLabsModule-module__font-s-10___c97oU`,
	"fontS12": `VitalsAndLabsModule-module__font-s-12___W_86y`,
	"fontS13": `VitalsAndLabsModule-module__font-s-13___Ol1Q7`,
	"fontS14": `VitalsAndLabsModule-module__font-s-14___qCRNC`,
	"fontS15": `VitalsAndLabsModule-module__font-s-15___cmffw`,
	"fontS16": `VitalsAndLabsModule-module__font-s-16___jnQt1`,
	"fontS18": `VitalsAndLabsModule-module__font-s-18___TUoxr`,
	"fontS20": `VitalsAndLabsModule-module__font-s-20___Tl2nZ`,
	"fontS22": `VitalsAndLabsModule-module__font-s-22___zUw1u`,
	"fontS28": `VitalsAndLabsModule-module__font-s-28___H1LcE`,
	"fontW400": `VitalsAndLabsModule-module__font-w-400___cBUp6`,
	"fontW500": `VitalsAndLabsModule-module__font-w-500___jUrD5`,
	"fontW600": `VitalsAndLabsModule-module__font-w-600___v8eAa`,
	"fontW700": `VitalsAndLabsModule-module__font-w-700___opYTU`,
	"p5": `VitalsAndLabsModule-module__p-5___GkW9G`,
	"p12": `VitalsAndLabsModule-module__p-12___PNWIR`,
	"p16": `VitalsAndLabsModule-module__p-16___RiPr5`,
	"p30": `VitalsAndLabsModule-module__p-30___vZ1PU`,
	"pB0": `VitalsAndLabsModule-module__p-b-0___nVy4x`,
	"pB5": `VitalsAndLabsModule-module__p-b-5___BzToY`,
	"pB10": `VitalsAndLabsModule-module__p-b-10___UNVtj`,
	"pB12": `VitalsAndLabsModule-module__p-b-12___Dk8bT`,
	"pB16": `VitalsAndLabsModule-module__p-b-16___qQpCI`,
	"pB18": `VitalsAndLabsModule-module__p-b-18___wGjmT`,
	"pB20": `VitalsAndLabsModule-module__p-b-20___eQoze`,
	"pB25": `VitalsAndLabsModule-module__p-b-25___qGNZW`,
	"pB30": `VitalsAndLabsModule-module__p-b-30___QX9SX`,
	"pB50": `VitalsAndLabsModule-module__p-b-50___Ge2dm`,
	"pT0": `VitalsAndLabsModule-module__p-t-0___g2A0k`,
	"pT12": `VitalsAndLabsModule-module__p-t-12___Mx5jL`,
	"pT16": `VitalsAndLabsModule-module__p-t-16___OC_B5`,
	"pT18": `VitalsAndLabsModule-module__p-t-18___zaSPL`,
	"pT20": `VitalsAndLabsModule-module__p-t-20___rC6fO`,
	"pT30": `VitalsAndLabsModule-module__p-t-30___u0OMB`,
	"pT40": `VitalsAndLabsModule-module__p-t-40___PmU5r`,
	"pT50": `VitalsAndLabsModule-module__p-t-50___lf37y`,
	"pL20": `VitalsAndLabsModule-module__p-l-20___KK7_n`,
	"pL30": `VitalsAndLabsModule-module__p-l-30___OKOtf`,
	"pL40": `VitalsAndLabsModule-module__p-l-40___oEWxi`,
	"pR16": `VitalsAndLabsModule-module__p-r-16___re5M4`,
	"pR20": `VitalsAndLabsModule-module__p-r-20___cJbA6`,
	"pR30": `VitalsAndLabsModule-module__p-r-30___Z99r0`,
	"pR50": `VitalsAndLabsModule-module__p-r-50___ZhE0C`,
	"pR60": `VitalsAndLabsModule-module__p-r-60___ILfJd`,
	"mB1": `VitalsAndLabsModule-module__m-b-1___OKCBi`,
	"mB2": `VitalsAndLabsModule-module__m-b-2___OYZWd`,
	"mB6": `VitalsAndLabsModule-module__m-b-6___jDLDH`,
	"mB8": `VitalsAndLabsModule-module__m-b-8___F4k5m`,
	"mB10": `VitalsAndLabsModule-module__m-b-10___Z6RDH`,
	"mB14": `VitalsAndLabsModule-module__m-b-14___bqXrk`,
	"mB16": `VitalsAndLabsModule-module__m-b-16___KP0Jy`,
	"mB20": `VitalsAndLabsModule-module__m-b-20___yaKQy`,
	"mB22": `VitalsAndLabsModule-module__m-b-22___VlNcH`,
	"mB24": `VitalsAndLabsModule-module__m-b-24___iUp92`,
	"mB30": `VitalsAndLabsModule-module__m-b-30___tQyq6`,
	"mB32": `VitalsAndLabsModule-module__m-b-32___pPPjk`,
	"mB40": `VitalsAndLabsModule-module__m-b-40___nB74C`,
	"mT2": `VitalsAndLabsModule-module__m-t-2___lDjph`,
	"mT3": `VitalsAndLabsModule-module__m-t-3___XMspH`,
	"mT4": `VitalsAndLabsModule-module__m-t-4___kB3iz`,
	"mT5": `VitalsAndLabsModule-module__m-t-5___ao4ac`,
	"mT8": `VitalsAndLabsModule-module__m-t-8___wmvle`,
	"mT10": `VitalsAndLabsModule-module__m-t-10___RN63Q`,
	"mT15": `VitalsAndLabsModule-module__m-t-15___CrrcQ`,
	"mT16": `VitalsAndLabsModule-module__m-t-16___KRAQ6`,
	"mT20": `VitalsAndLabsModule-module__m-t-20___HFh4q`,
	"mT22": `VitalsAndLabsModule-module__m-t-22___VCd9f`,
	"mT30": `VitalsAndLabsModule-module__m-t-30___qD85D`,
	"mT32": `VitalsAndLabsModule-module__m-t-32___riM05`,
	"mLAuto": `VitalsAndLabsModule-module__m-l-auto___yrQrp`,
	"mL4": `VitalsAndLabsModule-module__m-l-4___ROrTn`,
	"mL5": `VitalsAndLabsModule-module__m-l-5___p7O2F`,
	"mL6": `VitalsAndLabsModule-module__m-l-6___FHr2w`,
	"mL8": `VitalsAndLabsModule-module__m-l-8___dG9lL`,
	"mL10": `VitalsAndLabsModule-module__m-l-10___AbthJ`,
	"mL16": `VitalsAndLabsModule-module__m-l-16___geF9T`,
	"mL20": `VitalsAndLabsModule-module__m-l-20___CZoeu`,
	"mL24": `VitalsAndLabsModule-module__m-l-24___oxJ0C`,
	"mL30": `VitalsAndLabsModule-module__m-l-30___frMKI`,
	"mL35": `VitalsAndLabsModule-module__m-l-35___uS_xt`,
	"mL40": `VitalsAndLabsModule-module__m-l-40___ma_bB`,
	"mR8": `VitalsAndLabsModule-module__m-r-8___IdqFO`,
	"mR10": `VitalsAndLabsModule-module__m-r-10____2lO0`,
	"mR16": `VitalsAndLabsModule-module__m-r-16___o8djO`,
	"mR20": `VitalsAndLabsModule-module__m-r-20___h07eO`,
	"mR24": `VitalsAndLabsModule-module__m-r-24___hihtC`,
	"mR30": `VitalsAndLabsModule-module__m-r-30___oP43G`,
	"mR40": `VitalsAndLabsModule-module__m-r-40___hrblG`,
	"borderR3": `VitalsAndLabsModule-module__border-r-3___bgQ7s`,
	"borderR4": `VitalsAndLabsModule-module__border-r-4___FJSqj`,
	"borderR6": `VitalsAndLabsModule-module__border-r-6___QS9B3`,
	"borderR10": `VitalsAndLabsModule-module__border-r-10___CEBtI`,
	"borderR12": `VitalsAndLabsModule-module__border-r-12___kXAjh`,
	"borderR16": `VitalsAndLabsModule-module__border-r-16___i8yQj`,
	"borderR50": `VitalsAndLabsModule-module__border-r-50___GG5Ay`,
	"primaryBorder": `VitalsAndLabsModule-module__primary-border___SBmI1`,
	"primaryBorderB": `VitalsAndLabsModule-module__primary-border-b___Dmi2x`,
	"primaryBorderT": `VitalsAndLabsModule-module__primary-border-t___zkp81`,
	"primaryBorderL": `VitalsAndLabsModule-module__primary-border-l___g4mIK`,
	"primaryBorderR": `VitalsAndLabsModule-module__primary-border-r___iZTii`,
	"secondaryBorder": `VitalsAndLabsModule-module__secondary-border___ykOs0`,
	"secondaryBorderB": `VitalsAndLabsModule-module__secondary-border-b___UJlxp`,
	"secondaryBorderT": `VitalsAndLabsModule-module__secondary-border-t___CGJje`,
	"secondaryBorderL": `VitalsAndLabsModule-module__secondary-border-l___anxyU`,
	"secondaryBorderR": `VitalsAndLabsModule-module__secondary-border-r___oNcYO`,
	"gap0": `VitalsAndLabsModule-module__gap-0___m85Nu`,
	"gap2": `VitalsAndLabsModule-module__gap-2___JLz_s`,
	"gap4": `VitalsAndLabsModule-module__gap-4___X5m72`,
	"gap5": `VitalsAndLabsModule-module__gap-5___j0So5`,
	"gap6": `VitalsAndLabsModule-module__gap-6___bryZP`,
	"gap8": `VitalsAndLabsModule-module__gap-8___zlfYq`,
	"gap10": `VitalsAndLabsModule-module__gap-10___KZSJB`,
	"gap12": `VitalsAndLabsModule-module__gap-12___E0pz2`,
	"gap14": `VitalsAndLabsModule-module__gap-14___kcgnT`,
	"gap16": `VitalsAndLabsModule-module__gap-16___qSkKU`,
	"gap18": `VitalsAndLabsModule-module__gap-18___Q_UK5`,
	"gap20": `VitalsAndLabsModule-module__gap-20___LDBBw`,
	"gap24": `VitalsAndLabsModule-module__gap-24___KoEv9`,
	"gap26": `VitalsAndLabsModule-module__gap-26___sG7gg`,
	"gap30": `VitalsAndLabsModule-module__gap-30___Jfv1_`,
	"gap32": `VitalsAndLabsModule-module__gap-32___FyeXW`,
	"gap40": `VitalsAndLabsModule-module__gap-40___e_V9R`,
	"gap50": `VitalsAndLabsModule-module__gap-50___O_VFp`,
	"flex1": `VitalsAndLabsModule-module__flex-1___GAbTK`,
	"flexNone": `VitalsAndLabsModule-module__flex-none___lccQ3`,
	"flexColumn": `VitalsAndLabsModule-module__flex-column___BcXYP`,
	"flexRow": `VitalsAndLabsModule-module__flex-row___LpPiU`,
	"verticallyCentered": `VitalsAndLabsModule-module__vertically-centered___dBG_j`,
	"horizontallyCentered": `VitalsAndLabsModule-module__horizontally-centered___ZZF7s`,
	"horizontallyEnd": `VitalsAndLabsModule-module__horizontally-end___kaDoV`,
	"verticallyStart": `VitalsAndLabsModule-module__vertically-start___D2xem`,
	"spaceBetween": `VitalsAndLabsModule-module__space-between___Lbb_q`,
	"flexWrap": `VitalsAndLabsModule-module__flex-wrap___RsFKR`,
	"height100": `VitalsAndLabsModule-module__height-100___w0WP1`,
	"width50": `VitalsAndLabsModule-module__width-50___PMK4T`,
	"width100": `VitalsAndLabsModule-module__width-100___vKG_8`,
	"cursorPointer": `VitalsAndLabsModule-module__cursor-pointer___L3JNW`,
	"cursorNotAllowed": `VitalsAndLabsModule-module__cursor-not-allowed___kyiXv`,
	"absoluteCentered": `VitalsAndLabsModule-module__absolute-centered___jeDll`,
	"absolute": `VitalsAndLabsModule-module__absolute___Lurkn`,
	"relative": `VitalsAndLabsModule-module__relative___DhtHY`,
	"fixed": `VitalsAndLabsModule-module__fixed___bnRx8`,
	"visible": `VitalsAndLabsModule-module__visible___OBqpX`,
	"invisible": `VitalsAndLabsModule-module__invisible___urw3H`,
	"col90": `VitalsAndLabsModule-module__col-90___gihB6`,
	"colAuto": `VitalsAndLabsModule-module__col-auto___Oa3Kk`,
	"medicalTabs": `VitalsAndLabsModule-module__medical-tabs___yhyna`,
	"medicalTableNew": `VitalsAndLabsModule-module__medical-table-new___F3dNK`,
	"noPagination": `VitalsAndLabsModule-module__no-pagination___uJgsG`,
	"medicalTableEmpty": `VitalsAndLabsModule-module__medical-table-empty___i0KMN`,
	"iconBtn": `VitalsAndLabsModule-module__icon-btn___Vs_sQ`,
	"searchIcon": `VitalsAndLabsModule-module__search-icon___OKLCu`,
	"disableSelect": `VitalsAndLabsModule-module__disable-select___janId`,
	"breakWord": `VitalsAndLabsModule-module__break-word___LNS3L`,
	"popupClearBtn": `VitalsAndLabsModule-module__popup-clear-btn___CpqMj`,
	"scrollMB20": `VitalsAndLabsModule-module__scroll-m-b-20___czb9b`,
	"container": `VitalsAndLabsModule-module__container___PgOhN`,
	"width50": `VitalsAndLabsModule-module__width50___MG1EI`
};
module.exports = ___CSS_LOADER_EXPORT___;
